<template>
  <div class="bg-white p-4 rounded-lg mt-4 text-left text-textPrimary">
    <h2 class="text-md font-bold">Jornada de trabalho</h2>

    <div class="grid grid-cols-2 gap-4 mt-4">
      <div class="text-left">
        <h3 class="text-md font-semibold">Início</h3>
        <div class="flex items-center gap-2 mt-4">
          <v-icon size="small" :icon="mdiCalendarBlankOutline" :color="'iconGrey'" />
          <span class="text-sm">{{ formattedStartTime }}</span>
        </div>
      </div>

      <div class="text-left">
        <h3 class="text-md font-semibold">Fim</h3>
        <div class="flex items-center gap-2 mt-4">
          <v-icon size="small" :icon="mdiCalendarBlankOutline" :color="'iconGrey'" />
          <span class="text-sm">{{ formattedEndTime }}</span>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-4 mt-4">
      <div class="text-left">
        <h3 class="text-lg font-bold">Horas perdidas</h3>
        <p class="mt-2 text-sm text-negative">{{ formatDecimalHoursToHHMM(props.lostHours) }}</p>
      </div>

      <!-- <div class="text-left">
        <h3 class="text-lg font-bold">Prejuízo previsto</h3>
        <p class="mt-2 text-sm text-negative">{{ formatCurrency(props.estimatedLoss) }}</p>
      </div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { format } from 'date-fns'
import { mdiCalendarBlankOutline } from '@mdi/js'
import { formatDecimalHoursToHHMM } from '@/utils/formatters'

const props = defineProps({
  startTime: {
    type: Date as PropType<Date>,
    required: true
  },
  endTime: {
    type: Date as PropType<Date>,
    required: true
  },
  lostHours: {
    type: String,
    required: true
  },
  estimatedLoss: {
    type: Number,
    required: true
  }
})

const formattedStartTime = computed(() => {
  return format(props.startTime, "dd/MM/yyyy 'às' HH:mm")
})

const formattedEndTime = computed(() => {
  return format(props.endTime, "dd/MM/yyyy 'às' HH:mm")
})
</script>
